import { makeVar, useReactiveVar } from '@apollo/client';
import baseAppFeatures from '../../appFeatures';

export type AppFeatures = Partial<Record<keyof typeof baseAppFeatures, boolean>>;
export const appFeaturesVar = makeVar<AppFeatures>({});

/**
 * Retrieves appFeatures map from reactive variable
 *
 * When unit testing set the reactive variable directly instead of mocking this function:
 *
 * import { appFeaturesVar } from '@hooks/useAppFeatures';
 * appFeaturesVar({ myFoo: true });
 */
export default function useAppFeatures(): AppFeatures {
  return useReactiveVar(appFeaturesVar);
}
